<template>
  <div class="table-screes">
    <div class="screes-titel">
      <h2>筛选</h2>
      <img src="../../../../static/images/close.png" class="closeicon" @click="closeClick">
    </div>
    <div class="screes-warpper">
      <van-collapse v-model="activeName" accordion @change="getNameOut(activeName)">
         <van-collapse-item v-if="isHeadCompany()" name="0">
            <div slot="title">
              区
              <div v-show="areaShowText" class='text'>{{areaShowText}}</div>
            </div>
            <van-checkbox-group>
              <div class="itemBut">
                <van-button :class="{'itemButListH':checkedArea.indexOf(area.id)!=-1}" v-for="(area) in areas" :label="area.areaSName" :value="area.areaName" @click.native="handleCheckedAreaChange(area)" :key="area.areaSName">{{area.areaName}}</van-button>
              </div>
            </van-checkbox-group>
          </van-collapse-item>
        <van-collapse-item name="1">
          <div slot="title">
            机构
            <div v-show="textShow" class='text'>{{showText}}</div>
          </div>
          <MyTreeSelect ref="treeSelect" :type="'organization'" :filterType="'branch'" :items="branchs" v-on:chooseData1='getData1' v-on:chooseData2='getData2'></MyTreeSelect>
        </van-collapse-item>
        <van-collapse-item title="类型" name="2" v-show="firstMasterLevel.length===0">
          <div class="itemBut">
            <van-button :class="{'itemButListH':selectTypeArr.indexOf(itemBut.code)!=-1}" type="info" v-for="(itemBut, index) in typeData" :key="index"  @click="itemButClick(itemBut)">{{itemBut.name}}</van-button>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="(otherFiler.achievementName.indexOf('(')!=-1)?(otherFiler.achievementName.substring(0, otherFiler.achievementName.indexOf('('))):otherFiler.achievementName" name="3" class="inputBox">
          <van-cell-group>
            <van-field v-model="reachObj.reachMin" :placeholder="'最低('+otherFiler.achievementUnit+')'" />
          </van-cell-group>
          <span>---</span>
          <van-cell-group>
            <van-field v-model="reachObj.reachMax" :placeholder="'最高('+otherFiler.achievementUnit+')'" />
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="占比" name="4" class="inputBox">
          <van-cell-group>
            <van-field v-model="compareObj.compareMin" :placeholder="'最低('+otherFiler.comparedWithUnit+')'" />
          </van-cell-group>
          <span>---</span>
          <van-cell-group>
            <van-field v-model="compareObj.compareMax" :placeholder="'最高('+otherFiler.comparedWithUnit+')'" />
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item name="6" v-show='selectTypeArr.length===0'>
          <div slot="title" v-show="this.postKind !== '030401' || postQuota ==='T-A0102-1005'">
                       主销产品
             <div v-show="textShowMaster" class='text'>{{showTextMaster}}</div>
          </div>
          <div slot="title" v-show="this.postKind === '030401' && postQuota!=='T-A0102-1005'">
                       重点产品
             <div v-show="textShowMaster" class='text'>{{showTextMaster}}</div>
          </div>
          <MyTreeSelect ref="treeSelectPro" :type="'master'" :filterType="'product'" :items="master" v-on:chooseMasterData1='getDataMaster1' v-on:chooseMasterData2='getDataMaster2'></MyTreeSelect>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="screes-footer">
      <button @click="clearSelectedBranchs">重置</button>
      <button @click="childClick">确定</button>
    </div>
  </div>

</template>

<script>
import MyTreeSelect from './ProductTreeSelect'
// import MyTreeSelect from './MyTreeSelect1'
// import axios from 'axios'
import { postAction } from '@/utils/api'
export default {
  name: 'TablesScreens',
  components: {
    MyTreeSelect
  },
  // props接受子组件传的值
  props: ['timeIndex', 'otherFiler', 'typeData', 'selectedDate'],
  data () {
    return {
      modalFlag: '',
      dateData: this.selectedDate,
      areas: [
        {areaName: '东区', areaSName: '东', id: '861'},
        {areaName: '南区', areaSName: '南', id: '862'},
        {areaName: '西区', areaSName: '西', id: '863'},
        {areaName: '北区', areaSName: '北', id: '864'}
      ],
      areaShowText: '',
      checkedArea: [],
      childByValue: false,
      type: '',
      childValue: false,
      activeName: '0',
      branchs: [], // 筛选机构数据
      branchsCopy: [],
      orgBranchs: [],
      master: [],
      products: [],
      rates: {},
      sliderValue: [],
      sliderTick: [],
      firstLevel: [], // 一级内容
      secondLevel: [], // 二级内容
      firstMasterLevel: [], // 一级主销产品
      secondMasterLevel: [], // 二级主销产品
      showText: '',
      showTextMaster: '',
      textShow: false,
      textShowMaster: false,
      postChannel: '',
      postKind: '',
      postTime: '',
      postQuota: '',
      reachObj: {
        reachMin: '',
        reachMax: ''
      },
      compareObj: {
        compareMin: '',
        compareMax: ''
      },
      itemButText: [],
      selectTypeArr: [], // 选中的机构id  数组
      selectType: '', // 选中的类型id  字符串
      selectCode: '', // 选中的机构id
      saleProduct: '', // 主销产品
      riskType: '' // 类型id
      // mainData: {}
    }
  },
  methods: {
    /**
     * 选择区信息后处理逻辑
     * 1.切换当前按钮状态
     *    如果当前按钮未选中则将按钮放入到已选区checkedArea中。如果 已选中则在checkedArea 中将该区移除
     * 2.将区信息同步到机构数据中
     *    判断checkedArea是否为null 为空则显示所有机构。不为空则从this.orgBranchs中筛选出当前区的分公司和中支
     *    将过滤结果赋值给this.orgBranch(分公司)  this.branchs(中支)
     */
    handleCheckedAreaChange (area) {
      // 切换当前按钮状态
      this.$set(area, 'checked', !area.checked)
      if (area.checked) {
        this.checkedArea.push(area.id)
        this.checkedArea = [...new Set(this.checkedArea)]
      } else {
        for (let i = 0; i < this.checkedArea.length; i++) {
          if (this.checkedArea[i] === area.id) {
            this.checkedArea.splice(i, 1)
          }
        }
      }
      // 将区信息同步到机构数据中
      if (this.checkedArea.length > 0) {
        let result = JSON.parse(JSON.stringify(this.orgBranchs)).filter(item => {
          if (this.checkedArea.includes(JSON.stringify(item.areaCode))) {
            return item
          }
        })
        this.branchs = result
      } else {
        this.branchs = this.orgBranchs
      }
    },
    isHeadCompany () {
      return (this.$store.state.user.orgId === '86' && this.$store.state.user.areaFlag === '0' && this.$store.state.user.level === '1' && this.$store.state.user.pageCode === '02')
    },
    clearSelectedBranchs () {
      this.$store.commit('SCREENS_SET_SCREENORG', '') // 机构筛选
      this.$store.commit('SCREENS_SET_RISKTYPE', '') // 类型筛选
      this.$store.commit('SCREENS_SET_REACHSTART', '')
      this.$store.commit('SCREENS_SET_REACHEND', '')
      this.$store.commit('SCREENS_SET_PROPORTIONSTRAT', '')
      this.$store.commit('SCREENS_SET_PROPORTIONEND', '')
      this.$store.commit('SCREENS_SET_CHECKEDAREA', '')
      this.$store.commit('SCREENS_SET_SALEPRODUCT', '') // 主销产品
      for (let i = 0; i < this.areas.length; i++) {
        for (let k in this.areas[i]) {
          if (k === 'checked') {
            this.areas[i].checked = false
            delete this.areas[i][k]
          }
        }
      }
      for (let i = 0; i < this.typeData.length; i++) {
        for (let k in this.typeData[i]) {
          if (k === 'checked') {
            this.typeData[i].checked = false
            delete this.typeData[i][k]
          }
        }
      }
      this.branchs = JSON.parse(JSON.stringify(this.branchsCopy))
      let arr = []
      this.checkedArea = []
      this.selectTypeArr = JSON.parse(JSON.stringify(arr))
      this.selectType = ''
      if (this.isHeadCompany()) {
        this.activeName = '0'
      } else {
        this.activeName = ''
      }
      this.reachObj = {
        reachMin: '',
        reachMax: ''
      }
      this.compareObj = {
        compareMin: '',
        compareMax: ''
      }
      this.showText = '' // 清空城市名称回显
      this.showTextMaster = '' // 主销产品名称回显
      this.textShow = false
      this.textShowMaster = false
      if (this.firstLevel.length > 0 || this.secondLevel.length > 0) {
        this.$refs.treeSelect.clearConditions()
        this.$refs.treeSelect.clearTree()
      }
      if (this.firstMasterLevel.length > 0 || this.secondMasterLevel.length > 0) {
        this.$refs.treeSelectPro.clearConditions()
        this.$refs.treeSelectPro.clearMasterTree()
      }
    },
    getNameOut (activeNames) {
      if (activeNames === '1') {
        this.getName(activeNames)
      }
      if (activeNames === '6') {
        this.getName2(activeNames)
      }
      if (activeNames === '') {
        this.showText = ''
        this.showTextMaster = ''
        this.textShowMaster = false
        this.textShow = false
      }
    },
    getName2 (activeNames) {
      this.showTextMaster = ''
      if (!this.activeName) {
        this.textShowMaster = false
      } else {
        let firstMasterLevel = Object.values(this.$refs.treeSelectPro.selected1)
        let secondMasterLevel = Object.values(this.$refs.treeSelectPro.selected2)
        if (firstMasterLevel.length > 0) {
          for (let i = 0; i < firstMasterLevel.length; i++) {
            let chooseParent = firstMasterLevel[i].orgCode
            let chooseChild = []
            if (secondMasterLevel.length > 0) {
              for (let j = 0; j < secondMasterLevel.length; j++) {
                if (secondMasterLevel[j].parentId === chooseParent) {
                  chooseChild.push(secondMasterLevel[j])
                }
              }
            }
            this.showTextMaster = this.showTextMaster + '' + firstMasterLevel[i].orgSname
            if (chooseChild.length > 0) {
              for (let i = 0; i < chooseChild.length; i++) {
                if (i === 0) {
                  this.showTextMaster = this.showTextMaster + '-' + chooseChild[i].orgSname
                } else {
                  this.showTextMaster = this.showTextMaster + '、' + chooseChild[i].orgSname
                }
              }
            }
            this.showTextMaster = this.showTextMaster + ';'
          }
        }
        if (this.showTextMaster !== '') {
          this.textShowMaster = true
        }
      }
    },
    getName (activeNames) {
      this.showText = ''
      if (!this.activeName) {
        this.textShow = false
      } else {
        let firstLevel = Object.values(this.$refs.treeSelect.selected1)
        let secondLevel = Object.values(this.$refs.treeSelect.selected2)
        if (firstLevel.length > 0) {
          for (let i = 0; i < firstLevel.length; i++) {
            let chooseParent = firstLevel[i].orgCode
            let chooseChild = []
            if (secondLevel.length > 0) {
              for (let j = 0; j < secondLevel.length; j++) {
                if (secondLevel[j].parentId === chooseParent) {
                  chooseChild.push(secondLevel[j])
                }
              }
            }
            this.showText = this.showText + '' + firstLevel[i].orgSname
            if (chooseChild.length > 0) {
              for (let i = 0; i < chooseChild.length; i++) {
                if (i === 0) {
                  this.showText = this.showText + '-' + chooseChild[i].orgSname
                } else {
                  this.showText = this.showText + '、' + chooseChild[i].orgSname
                }
              }
            }
            this.showText = this.showText + ';'
          }
        }
        if (this.showText !== '') {
          this.textShow = true
        }
      }
    },
    childClick () { // 确定提交
      this.selectCode = ''
      this.saleProduct = ''
      this.$store.commit('SCREENS_SET_SCREENORG', this.getMoreLevelParams(this.selectCode, this.firstLevel, this.secondLevel)) // 机构筛选
      this.$store.commit('SCREENS_SET_RISKTYPE', this.selectTypeArr.join(',')) // 类型筛选
      this.$store.commit('SCREENS_SET_REACHSTART', this.reachObj.reachMin)
      this.$store.commit('SCREENS_SET_REACHEND', this.reachObj.reachMax)
      this.$store.commit('SCREENS_SET_PROPORTIONSTRAT', this.compareObj.compareMin)
      this.$store.commit('SCREENS_SET_CHECKEDAREA', [...this.checkedArea])
      this.$store.commit('SCREENS_SET_PROPORTIONEND', this.compareObj.compareMax)
      this.$store.commit('SCREENS_SET_SALEPRODUCT', this.riddingUnbalance(this.getMoreLevelParams(this.saleProduct, this.firstMasterLevel, this.secondMasterLevel))) // 主销产品
      // this.$store.state.screens.screenOrg = this.getMoreLevelParams(this.selectCode, this.firstLevel, this.secondLevel) // 机构筛选
      // this.$store.state.screens.riskType = this.selectTypeArr.join(',')// 类型筛选
      // this.$store.state.screens.saleProduct = this.getMoreLevelParams(this.saleProduct, this.firstMasterLevel, this.secondMasterLevel) // 主销产品
      // this.$store.state.screens.reachStart = this.reachObj.reachMin
      // this.$store.state.screens.reachEnd = this.reachObj.reachMax
      // this.$store.state.screens.proportionStrat = this.compareObj.compareMin
      // this.$store.state.screens.proportionEnd = this.compareObj.compareMax
      this.$emit('childByValue', this.childValue)
    },
    // 去重
    riddingUnbalance (str) {
      let newstr = ''
      // let string = ''
      let arr = str.split(',')
      let newArr = []
      for (let i = 0; i < arr.length; i++) {
        if (newArr.indexOf(arr[i]) === -1) {
          newArr.push(arr[i])
        }
      }
      arr = newArr
      newstr = arr.join(',')
      return newstr
    },
    // 获取多级参数的方法，str为拼接的参数，level1为一级选中数据，level2为2级选中数据
    getMoreLevelParams (str, level1, level2) {
      if (level1 != null && level1.length > 0 && level1[0].orgCode.indexOf('86') !== -1) {
        for (let i = 0; i < level1.length; i++) {
          if (str === '') {
            str = str + level1[i].orgCode
          } else {
            str = str + ',' + level1[i].orgCode
          }
        }
        for (let j = 0; j < level2.length; j++) {
          if (str === '') {
            str = str + level2[j].orgCode
          } else {
            str = str + ',' + level2[j].orgCode
          }
        }
        // for (let m = 0; m < level1.length; m++) {
        //   for (let i = 0; i < level1[m].children.length; i++) {
        //     if (str === '') {
        //       str = str + level1[m].children[i].orgCode
        //     } else {
        //       str = str + ',' + level1[m].children[i].orgCode
        //     }
        //   }
        // }
        // for (let j = 0; j < level2.length; j++) {
        //   if (str === '') {
        //     str = str + level2[j].orgCode
        //   } else {
        //     str = str + ',' + level2[j].orgCode
        //   }
        // }
      } else {
        // 遍历二级产品，判断一级是否含有二级数据，如果含有，不取其children,否者取其所有children值
        let notAll = []
        for (let i = 0; i < level2.length; i++) {
          let productCodeTemp2 = level2[i].orgCode
          for (let j = 0; j < level1.length; j++) {
            let hasItem = false
            for (let k = 0; k < level1[j].children.length; k++) {
              let productCodeTemp1 = level1[j].children[k].orgCode
              if (productCodeTemp1 === productCodeTemp2) {
                hasItem = true
              }
              // if()
            }
            if (hasItem) {
              notAll.push(level1[j])
            }
          }
        }
        // 去掉非全选内容
        let level1Bak = level1.concat()
        for (let m = 0; m < notAll.length; m++) {
          for (let n = 0; n < level1Bak.length; n++) {
            if (level1Bak[n] !== null && level1Bak[n] !== undefined && notAll[m].orgCode === level1Bak[n].orgCode) {
              delete level1Bak[n]
            }
          }
        }
        // level1Bak.push(level2.[])
        let level1BakA = []
        for (let q = 0; q < level1Bak.length; q++) {
          if (level1Bak[q] !== null && level1Bak[q] !== undefined && level1Bak[q].children !== null) {
            for (let h = 0; h < level1Bak[q].children.length; h++) {
              level1BakA.push(level1Bak[q].children[h])
            }
          }
        }
        // 整合 一级转换二级后与真实二级所有被选中的数据
        let level1BakALL = level1BakA.concat(level2)
        for (let b = 0; b < level1BakALL.length; b++) {
          if (level1BakALL[b] !== '') {
            if (str === '') {
              str = level1BakALL[b].orgCode
            } else {
              str = str + ',' + level1BakALL[b].orgCode
            }
            // for (let h = 0; h < level1BakALL[b].length; h++) {
            //   str = level1BakALL[b].orgCode
            // }
          }
        }
      }
      return str
    },
    /*
      类型选择选中处理和取消选中处理
     */
    itemButClick (itemBut) {
      this.$set(itemBut, 'checked', !itemBut.checked)
      // 选中的类型id
      if (itemBut.checked) {
        this.selectTypeArr.push(itemBut.code)
        this.selectTypeArr = [...new Set(this.selectTypeArr)]
      } else {
        for (let i = 0; i < this.selectTypeArr.length; i++) {
          if (this.selectTypeArr[i] === itemBut.code) {
            this.selectTypeArr.splice(i, 1)
          }
        }
      }
    },
    closeClick () {
      // 如果不点击确认按钮  传入标志
      let closeFlag = 1
      // this.$store.state.user.modalFlag=0
      console.log(this.$store.state.user.modalFlag)
      this.$store.commit('MODAL_GLAG', 0)
      this.$emit('childByValue', this.childValue, closeFlag)
    },
    getFilterData (data) {
      if (data) {
        this.orgBranchs = [...data.data]
        if (this.checkedArea.length === 0) {
          this.branchs = [...this.orgBranchs]
        } else {
          this.branchs = this.orgBranchs.filter(branch => this.checkedArea.includes(JSON.stringify(branch.areaCode)))
        }
        this.branchsCopy = JSON.parse(JSON.stringify(this.orgBranchs))
      }
    },
    getChangeKey (arr) {
      for (let i = 0; i < arr.length; i++) {
        arr[i].orgCode = arr[i].id
        arr[i].orgSname = arr[i].name
        arr[i].parentId = arr[i].pid
        if (arr[i].children && arr[i].children.length) {
          this.getChangeKey(arr[i]['children'])
        }
      }
    },
    getFilterDataTwo (data) {
      if (data) {
        this.getChangeKey(data.data)
        this.master = data.data
      }
    },
    getFilterDataThree (data) {
      if (data) {
        this.getChangeKey(data.data)
        this.master = data.data
      }
    },
    getData1 (data) {
      this.firstLevel = data
      let areasNew = this.areas // 建立新的区数组
      for (let j = 0; j < data.length; j++) {
        for (let i = 0; i < areasNew.length; i++) {
          if ((data[j].areaCode + '').indexOf(areasNew[i].id + '') !== -1) {
            if (this.checkedArea.length <= 0) {
              this.handleCheckedAreaChange(areasNew[i])
            } else {
              for (let m = 0; m < this.checkedArea.length; m++) {
                if ((areasNew[i].id + '').indexOf(this.checkedArea[m]) !== -1) {
                  return
                } else {
                  // 选择区后选择一级机构后数据错乱
                  // this.itemButClick(areasNew[i])
                }
              }
            }
          }
        }
      }
    },
    getData2 (data) {
      this.secondLevel = data
    },
    getDataMaster1 (data) {
      this.firstMasterLevel = data
    },
    getDataMaster2 (data) {
      this.secondMasterLevel = data
    },
    loads () {
      this.postChannel = this.$store.state.entirety.channel
      this.postKind = this.$store.state.entirety.kind
      this.postTime = this.$store.state.entirety.time
      this.postQuota = this.$store.state.entirety.quota
      let postData = {
        'channelId': this.postChannel,
        'classification': this.postKind,
        'dateType': this.postTime,
        'indexId': [this.postQuota],
        'date': this.dateData || '',
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId,
        'pageCode': this.$store.state.user.pageCode
      }
      // let obj = postAction('/simpapp/Filtrate/getList', postData)
      // obj.then(this.getFilterData)
      let objOne = postAction('/simpapp/Filtrate/getList', postData)
      objOne.then(this.getFilterData)
      // this.mainData = this.$store.state.entirety.mainProductList
      if (this.postKind !== '030401' || this.postQuota === 'T-A0102-1005') {
        let objTwo = postAction('/simpapp/Filtrate/getMainProductList', postData)
        objTwo.then(this.getFilterDataTwo)
      } else {
        let objThree = postAction('/simpapp/Filtrate/getKeyProductList', postData)
        objThree.then(this.getFilterDataThree)
      }
    }
  },
  created () {
    // 调用接口方法
    this.loads()
  },
  mounted () {
    this.itemButText = this.typeData
  },
  watch: {
    // 监听新旧数据的变化
    isFollow (newVal, oldVal) {
    // do something
      if (newVal === 1) {
        this.loads()
      }
    },
    // 监听传值
    selectedDate (v) {
      this.dateData = v
    },
    typeData () {
      let log = false
      for (let i = 0; i < this.typeData.length; i++) {
        if (this.selectTypeArr.indexOf(this.typeData[i].code) !== -1) {
          log = true
        }
      }
      if (!log) {
        this.selectTypeArr = []
      }
    },
    orChangeList (val) {
      let mainData = this.$store.state.entirety.mainProductList
      this.getFilterDataTwo(mainData)
      this.getFilterDataThree(mainData)
    },
    timeIndex () {
      if (this.isHeadCompany()) {
        this.activeName = '0'
      }
    }
  },
  computed: {
    orChangeList () {
      return this.$store.state.entirety.mainProductList
    },
    isFollow () {
      return this.$store.state.user.modalFlag // 需要监听的数据
    }
  }
}
</script>

<style lang="stylus" scoped>
.table-screes{
  margin : 0 auto;
  text-align : center;
}
.screes-titel, .screes-titel h2{
  height 0.5rem
  line-height .5rem
}
.screes-warpper{
  text-align : left;
  height: 3rem;
  overflow: hidden;
  overflow-y: scroll;
}
.screes-all span{
  margin-right : .2rem;
}
.screes-city{
  margin-top : .1rem;
  display : flex;
  justify-content : center;
}
.screes-city .van-button{
  flex : 1;
  margin : .01rem;
  font-size : 2vw;
  height : auto;
  line-height : 3;
}
.van-button--normal{
  padding : .01rem;
  width: 50px;
  height: 40px;
  color: #1989fa;
  background-color: #fff;
  border: 1px solid #1989fa;
}
.screes-footer{
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: stretch;
}
.screes-footer>button{
  background-color: #fff;
  flex-grow:1;
  box-sizing: border-box;
  padding:.08rem 0;
}
.screes-footer>button:nth-child(1){
  border-top:1px solid #bfbfbf;
  color:#bfbfbf;
}
.screes-footer>button:nth-child(2){
  border-top:1px solid #3399ff;
  color:#fff;
  background-color: #3399ff;
}
.complete-rate{
  overflow:hidden;
  box-sizing:border-box;

}
.complete-rate>div{
  border:1px solid #f9f9f9;
  width:30%;
  float:left;
  padding:.12rem 0;
  text-align: center;
  margin-left:2.5%;
  margin-bottom:2.5%;
  border-radius:.06rem;
  background-color: #f9f9f9;
  color:#999999;
}
.sliderTick{
  overflow:hidden;
}
.sliderTick>div{
  box-sizing: border-box;
  float:left;
}
.sliderTick>div:last-child{
  float:right;
}
.screes-warpper>>>.el-slider__button{
  width: 25px;
  height: 25px;
  box-shadow: 0px 0px 15px #ddd;
  border: none;
}
.sliderCurrent{
  text-align: center;
  color:#3399ff;
}

.itemBut{
  display : flex;
  justify-content : space-around;
  margin-top: -9px;
}
.itemBut>button{
  display : block;
  color: #1989fa;
  background-color: #fff;
  border: 1px solid #1989fa;
  padding: 0 0.05rem;
}
// .itemButList{
//   display : block;
//   color: #1989fa;
//   background-color: #fff;
//   border: 1px solid #1989fa;
//   padding: 0 0.2rem;
// }
.itemButListH{
  color: #fff !important;
  background-color: #1989fa !important;
  border-width : 0;
}
.text {
  color:#999;
  font-weight:normal;
  margin:10px 0 8px 0;
  width:100%;
  word-break:break-all;
  text-overflow:ellipsis;//显示为省略号
  display:-webkit-box;//对象作为伸缩盒子模型显示
  -webkit-box-orient:vertical;//设置或检索伸缩盒对象的子元素的排列方式
  -webkit-line-clamp:2;//显示行数## 标题文字 ##
  overflow:hidden;
}
.screes-warpper>>>.van-collapse-item__content {
  padding: 10px!important;
}
.inputBox>>>.van-collapse-item__wrapper .van-collapse-item__content{
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-cell{
  color: #999!important;
  font-weight:normal
}
.inputBox .van-cell-group{
  display inline-block
  width:30%;
  border:none
}
.van-cell.van-field{
  background-color:#f9f9f9 !important
}
.closeicon {
  position: absolute;
  width:.21rem;
  height:.2rem
  top: 15px;
  right: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/analyseScreen/ProductScreens.vue